export const MOOSEND_NEWSLETTER_URL = `https://api.moosend.com/v3/subscribers/8bf6c9eb-6d7a-4991-8660-4345f52231d7/subscribe.json?apikey=${process.env.GATSBY_MOOSEND_NEWSLETTER_API_KEY}`;
